export const GET_FOURNITURE_SUCCESS = "GET_FOURNITURE_SUCCESS";
export const GET_FOURNITURE_LOAD = "GET_FOURNITURE_LOAD";
export const GET_FOURNITURE_FAILD = "GET_FOURNITURE_FAILD";
